<template>
    <div>
        <button class="button button--primary" @click="open = true">{{ $translations.notify.notify_me }}</button>
        <single-product-promote :open="open" @close="open = false" :embedCode="embedCode"/>
    </div>
</template>

<script>
import SingleProductPromote from './single-product-promote.vue';

export default {
    components: { SingleProductPromote },
    selector: '#vue-single-product-promote-wrapper',
    props: ['embedCode'],
    data() {
        return {
            open: false,
        }
    }
}
</script>

<style>

</style>